<app-guest-header [innerPage]="true"></app-guest-header>

<div class="main-body">
    <div class="text-center">
        <p></p>
        <p class="txt-black fs-4" style="margin-bottom: 0px;"><i class="fas fa-book fa-lg" style="color: #000080;"></i> คำแนะนำ/คู่มือ การใช้งานระบบงานคดีปกครองอิเล็กทรอนิกส์สำหรับประชาชน</p>
        <p class="txt-black fs-4" style="margin-bottom: 0px;">และหน่วยงานทางปกครองหรือเจ้าหน้าที่ของรัฐ</p>
    </div>



    <div class="container">

    <div class="row col-md-12" style="padding-top: 0%;">
    <div class="accordion" id="accordionExample">
        <div class="accordion-item">
          <h2 class="accordion-header">
            <button class="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
              เอกสารคู่มือแนะนำการใช้งานระบบ
            </button>
          </h2>
          <div id="collapseOne" class="accordion-collapse collapse show" data-bs-parent="#accordionExample">
            <div class="accordion-body">
             

                <div class="container">
                    <div class="row" style="padding-top: 1%;padding-bottom:1%">
                        <div class="col-md-2"></div>
                        <div class="col-md-1 text-start">แสดง</div>
                        <div class="col-md-1">
                           
                             <select class="form-select" 
                                data-bs-toggle="tooltip" 
                                data-bs-placement="top" 
                                title="เลือกจำนวนหน้าที่ต้องการแสดง"  
                                [(ngModel)]="pageRequest.pageSize"
                                (change)="onPageSizeChange($event)"
                                >
                                <option [value]="10">10</option>
                                <option [value]="20">20</option>
                                <option [value]="30">30</option>
                                <option [value]="40">40</option>
                             </select>
                            
                            <!--<ngx-select 
                            [(ngModel)]="pageRequest.pageSize" [ngModelOptions]=" {standalone: true}" [placeholder]="'เลือกจำนวนหน้าที่ต้องการแสดง'"
                            (select)="onBoardTypeSelect($event)">
                            </ngx-select>-->
                        </div>
                        <div class="col-md-1">รายการ</div>
                        
                        <div class="col-md-2">
                            ค้นหาจากชื่อเอกสาร
                        </div>
                        <div class="col-md-3">
                            
                            <input type="text" class="form-control" [(ngModel)]="pageRequest.criteria.detail" (input)="search()" placeholder="ค้นหาจากชื่อเอกสารตั้งแต่ 3 ตัวอักษร">
                            
                            <!--
                            <input class="form-control"  matInput (keyup)="search($event)" placeholder="ค้นหาจากชื่อเอกสารตั้งแต่ 3 ตัวอักษรขึ้นไป"/>
                            -->
                        </div>
                       
                    </div>
            
                    <div class="row" style="padding-bottom: 0%;">
                        <div class="col-md-2"></div>
                        <!---->
                        <div class="col-md-8">
                            <div class="table-custom">
                                <table class="table table-borderless mb-0 table-responsive-sm" role="table">
                                    <thead role="rowgroup">
                                        <tr role="row">
                                            <th scope="col" class="text-center" style="width: 10%;" role="columnheader">ลำดับที่</th>
                                            <th scope="col" class="text-center" style="width: 80%;" role="columnheader">คู่มือ</th>
                                            <th scope="col" class="text-center" style="width: 10%;" role="columnheader">ไฟล์</th>
                                        </tr>
                                    </thead>
                                    <tbody class="table-group-divider" *ngFor="let item of items ; let i=index" role="rowgroup">
                                        <tr class="text-blue" [ngClass]="{'even-td-color': (i+1)%2 ==0}">
                                            <td scope="row" role="cell" class="text-center">{{i+1}}</td>
                                            <td role="cell">{{item.muDetail}}</td>
                                            <td style="cursor: pointer;" role="cell">
                                                <h2><i class="fa fa-file-pdf" style="color: #ff0000;" (click)="download(item.muUrl)"></i>
                                                </h2>
                                            </td>
                                        </tr>
                    
                    
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        <div class="col-md-2"></div>
                    
                    </div>
            
                    
            
                    <div class="row col-md-12" style="padding-top: 0%;">
                        <div class="col-md-2">
                    
                        </div>
                    
                        <div class="col-md-4  bg-blue " style="margin-left: 0.9%;">
                    
                    
                            <div class="txt-white">
                                <p class="txt-white">แสดง {{pageResponse.pageNumber}} ถึง {{pageResponse.pageSize}} จาก
                                    {{pageResponse.totalItemCount}} รายการ</p>
                            </div>
                      
                    
                        </div>
            
            
                        
                        <div class="col-md-4 bg-blue manualMobile ">
                       
                            <div class="bg-blue ">
                                <app-paginator #pagination (onPageChange)="onPageChange($event)"></app-paginator>
                            </div>
                
                        </div>
                    
                        
                    </div>
            
                </div>



            </div>
          </div>
        </div>
        <div class="accordion-item">
          <h2 class="accordion-header">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
              สื่อมัลติมีเดียแนะนำการใช้งานระบบ
            </button>
          </h2>
          <div id="collapseTwo" class="accordion-collapse collapse" data-bs-parent="#accordionExample">
            <div class="accordion-body">
            
            
                <div class="container">
                    <div class="row" style="padding-top: 1%;padding-bottom:1%">
                        <div class="col-md-1"></div>
                        <div class="col-md-1 text-start">แสดง</div>
                        <div class="col-md-1">
                           
                             <select class="form-select" 
                                data-bs-toggle="tooltip" 
                                data-bs-placement="top" 
                                title="เลือกจำนวนหน้าที่ต้องการแสดง"  
                                [(ngModel)]="pageRequestLink.pageSize"
                                (change)="onPageSizeChangeLink($event)"
                                >
                                <option [value]="10">10</option>
                                <option [value]="20">20</option>
                                <option [value]="30">30</option>
                                <option [value]="40">40</option>
                             </select>
                            
                            <!--<ngx-select 
                            [(ngModel)]="pageRequestLink.pageSize" [ngModelOptions]=" {standalone: true}" [placeholder]="'เลือกจำนวนหน้าที่ต้องการแสดง'"
                            (select)="onBoardTypeSelect($event)">
                            </ngx-select>-->
                        </div>
                        <div class="col-md-1">รายการ</div>
                        
                        <div class="col-md-4">
                            ค้นหาจากชื่อสื่อมัลติมีเดียแนะนำการใช้งานระบบ
                        </div>
                        <div class="col-md-3">
                            
                            <input type="text" 
                            class="form-control" 
                            [(ngModel)]="pageRequestLink.criteria.detail" 
                            (input)="searchLink()" 
                            placeholder="ค้นหาจากชื่อตั้งแต่ 3 ตัวอักษร">
                            
                            <!--
                            <input class="form-control"  matInput (keyup)="search($event)" placeholder="ค้นหาจากชื่อเอกสารตั้งแต่ 3 ตัวอักษรขึ้นไป"/>
                            -->
                        </div>
                       
                    </div>
            
                    <div class="row" style="padding-bottom: 0%;">
                        <div class="col-md-1"></div>
                        <!---->
                        <div class="col-md-10">
                            <div class="table-custom">
                                <table class="table table-borderless mb-0 table-responsive-sm" role="table">
                                    <thead role="rowgroup">
                                        <tr role="row">
                                            <th scope="col" class="text-center" style="width: 10%;" role="columnheader">ลำดับที่</th>
                                            <th scope="col" class="text-center" style="width: 80%;" role="columnheader">ชื่อสื่อมัลติมีเดีย</th>
                                            <th scope="col" class="text-center" style="width: 10%;" role="columnheader">Link</th>
                                        </tr>
                                    </thead>
                                    <tbody class="table-group-divider" *ngFor="let itemL of itemsLink ; let i=index" role="rowgroup">
                                        <tr class="text-blue" [ngClass]="{'even-td-color': (i+1)%2 ==0}">
                                            <td scope="row" role="cell" class="text-center">{{i+1}}</td>
                                            <td role="cell">{{itemL.lmDetail}}</td>
                                            <td style="cursor: pointer;" role="cell">
                                               <!--{{itemL.lmUrl}}--> 

                                               <h2>
                                               

                                                <!--   
                                                    1. youtube
                                                    2. tiktok
                                                    3. facebook
                                                    4. instragram

                                                -->
                                               
                                                <i class="fab fa-youtube fa-lg text-danger"  *ngIf="itemL.lmType=='1'" (click)="download(itemL.lmUrl)"></i>
                                                <i class="fab fa-tiktok fa-lg text-dark"  *ngIf="itemL.lmType=='2'" (click)="download(itemL.lmUrl)"></i>
                                                <i class="fab fa-facebook-square fa-lg text-primary" *ngIf="itemL.lmType=='3'" (click)="download(itemL.lmUrl)"></i>
                                                <i class="fab fa-instagram-square fa-lg" style="color:#C21292;" *ngIf="itemL.lmType=='4'" (click)="download(itemL.lmUrl)"></i>

                                               </h2>
                                            </td>
                                        </tr>
                    
                    
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        <div class="col-md-1"></div>
                    
                    </div>
            
                    
            
                    <div class="row col-md-12" style="padding-top: 0%;">
                        <div class="col-md-1">
                    
                        </div>
                    
                        <div class="col-md-6  bg-blue " style="margin-left: 0.9%;">
                    
                    
                            <div class="txt-white">
                                <p class="txt-white">แสดง {{pageResponseLink.pageNumber}} ถึง {{pageResponseLink.pageSize}} จาก
                                    {{pageResponseLink.totalItemCount}} รายการ</p>
                            </div>
                      
                    
                        </div>
            
            
                        
                        <div class="col-md-4 bg-blue manualMobile ">
                       
                            <div class="bg-blue ">
                                <app-paginator #pagination (onPageChange)="onPageChangeLink($event)"></app-paginator>
                            </div>
                
                        </div>
                    
                        
                    </div>
            
                </div>


            
            
            
            
            
            
            
            
            
            
            
            
            </div>
          </div>




        </div>

      </div>
    </div>
</div>







</div>

<div class="row" style="padding-top: 5%;">
</div>













<app-guest-footer>

</app-guest-footer>
